<template>
  <div id="layerPanel" class="layerPanel" @mousedown="startDragging" @mouseup="stopDragging" @mousemove="dragPanel" @wheel.stop @mouseenter="$emit('diableMapDragAndZoom')"
    @mouseleave="$emit('enableMapDragAndZoom')">
    <div class="main-title">
      <h3>图层面板</h3>
      <button @click="$emit('closeLayerPanel')">X</button>
    </div>
    <!-- 行政区划图层 -->
    <div>
      <h4 @click="toggleSection('xzqh')">
        {{ isSectionOpen('xzqh') ? '▼' : '▶' }} 行政区划图层
      </h4>
      <ul v-show="isSectionOpen('xzqh')">
        <li v-for="layer in mLayers.xzqhLayers" :key="layer.TCBH">
            <label><input type="checkbox" v-model="layer.isVisiable" @change="$emit('setLayerVisiable',{layer:layer,isVisiable: $event.target.checked})">{{ layer.TCJC }}</label>
        </li>
      </ul>
    </div>
    <!-- 基础图层 -->
    <div>
      <h4 @click="toggleSection('gbkj')">
        {{ isSectionOpen('gbkj') ? '▼' : '▶' }} 基础图层
      </h4>
      <ul v-show="isSectionOpen('gbkj')">
        <li v-for="layer in mLayers.gbkjLayers" :key="layer.TCBH">
            <label><input type="checkbox" v-model="layer.isVisiable"  @change="$emit('setLayerVisiable',{layer:layer,isVisiable: $event.target.checked})">{{ layer.TCJC }}</label>
            <div class="opacity-control" @mousedown.stop @mousemove.stop>
              <span class="opacity-label">透明度</span>
              <input type="range" min="0" max="100"
                :value="opacityMap[layer.TCBH] !== undefined ? opacityMap[layer.TCBH] : 100"
                @input="handleOpacityInput(layer, $event)" class="opacity-slider" />
              <span class="opacity-value">{{ opacityMap[layer.TCBH] !== undefined ? opacityMap[layer.TCBH] : 100 }}%</span>
            </div>
        </li>
      </ul>
    </div>
    <!-- 其他图层 -->
    <div>
      <h4 @click="toggleSection('qt')">
        {{ isSectionOpen('qt') ? '▼' : '▶' }} 其他图层
      </h4>
      <ul v-show="isSectionOpen('qt')">
        <li v-for="layer in mLayers.qtLayers" :key="layer.TCBH">
            <label><input type="checkbox" v-model="layer.isVisiable"  @change="$emit('setLayerVisiable',{layer:layer,isVisiable: $event.target.checked})">{{ layer.TCJC }}</label>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LayerPanel',
  props: {
    mLayers: {
      type: Object,
      default: () => ({
        xzqhLayers: [],
        gbkjLayers: [],
        qtLayers: [],
      }),
    },
  },
  created() {
    this.initOpacity(this.mLayers.gbkjLayers);
  },
  data() {
    return {
      isDragging: false,
      startX: 0,
      startY: 0,
      offsetX: 0,
      offsetY: 0,
      layerOpacities: {},
      opacityMap: {},
      openSections: {
        xzqh: true,
        gbkj: true,
        qt: true,
      },
    };
  },
  methods: {
    startDragging(event) {
      event.stopPropagation(); // 阻止事件冒泡
      this.isDragging = true;
      this.startX = event.clientX;
      this.startY = event.clientY;
      this.offsetX = this.$el.offsetLeft;
      this.offsetY = this.$el.offsetTop;
      document.addEventListener('mousemove', this.drag);
      document.addEventListener('mouseup', this.stopDrag);
    },
    stopDragging() {
      this.isDragging = false;
      document.removeEventListener('mousemove', this.drag);
      document.removeEventListener('mouseup', this.stopDrag);
    },
    dragPanel(event) {
      event.stopPropagation(); // 阻止事件冒泡
      if (this.isDragging) {
        const dx = event.clientX - this.startX;
        const dy = event.clientY - this.startY;
        this.$el.style.left = `${this.offsetX + dx}px`;
        this.$el.style.top = `${this.offsetY + dy}px`;
      }
    },
    toggleSection(section) {
      this.openSections[section] = !this.openSections[section];
    },
    isSectionOpen(section) {
      return this.openSections[section];
    },
    initOpacity(layers) {
      if (!layers) return;
      layers.forEach(layer => {
        if (this.opacityMap[layer.TCBH] === undefined) {
          this.opacityMap[layer.TCBH] = 100;
        }
      });
    },
    handleOpacityInput(layer, event) {
      const val = Number(event.target.value);
      console.log('[LayerPanel] slider input fired, TCBH:', layer.TCBH, 'TCJC:', layer.TCJC, 'val:', val);
      this.opacityMap[layer.TCBH] = val;
      this.$emit('setLayerOpacity', { layer: layer, opacity: val / 100 });
    },
  },
};
</script>

<style scoped>
.layerPanel {
  left: var(--panel-left, 20px);
  top: var(--panel-top, 15vh);
  position: fixed;
  z-index: 1000;
  background-color: white;
  border: 1px solid #ccc;
  padding: 10px;
  width: 250px;
  overflow: hidden;
}

.main-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f4f4f4;
  padding: 2px 5px;
  height: 30px;
}

.main-title h3 {
  font-size: 16px;
  margin: 0;
}

div > h4 {
  cursor: pointer;
  background-color: #eaeaea;
  padding: 5px;
  margin: 0;
  text-align: left;
}

ul {
  background-color: #f9f9f9;
  padding: 5px;
  list-style: none;
  margin: 0;
}
ul li {
  text-align: left;
  cursor: pointer;
  padding-left: 15px;
}

.opacity-control {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 2px 5px 2px 15px;
  font-size: 12px;
}

.opacity-label {
  color: #666;
  white-space: nowrap;
  flex-shrink: 0;
}

.opacity-slider {
  flex: 1;
  min-width: 0;
  height: 4px;
  cursor: pointer;
  accent-color: #409eff;
}

.opacity-value {
  min-width: 32px;
  text-align: right;
  color: #333;
  flex-shrink: 0;
}
</style>
